import { stringifyUrlQuery } from 'helpers';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  GetBoardTemplatesRequestType,
  GetBoardTemplatesResponseType,
} from '../types';

export const getBoardTemplates = async ({
  pathParams: { organisationId, boardId },
  queryParams: {
    base,
    from,
    id,
    name,
    page,
    perPage,
    public: publicParam,
    sortBy,
    sortDir,
    to,
  },
}: GetBoardTemplatesRequestType) => {
  const query = stringifyUrlQuery({
    base,
    from,
    id,
    name,
    page,
    perPage,
    public: publicParam,
    sortBy,
    sortDir,
    to,
  });

  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/templates${query}`;

  const { data } = await apiAuthClient.get<GetBoardTemplatesResponseType>(url);

  return data;
};
